/*
Theme Name: pxlr-cocoon-store
Theme URI: https://pxlr-cocoon.px
Author: Pierre Brost
Author URI: http://www.pixelizer.de
Version: 1.0.0
Text Domain: pxlr-cocoon
File: woocommerce.js
Desc: custom js for woocommerce
*/


/**
 * **************************************************************************
 * PXLR WOOCommerce Form Label and input are nestedm thats supid ************
 * Let toggleClass to every clicked label to add custom styling *************
 * 
 * We just need change event binding instead of click
 * Binding a change event would only trigger the event once 
 * ( only for checkbox ) which would toggle the class correctly.
 * 
 * Explanation:
 * It turns out that when you click on the label, it also invokes the click 
 * event on the input:checkbox ( because of nested element wrapping ). 
 * Because of this, the 1st event on the label does sets the class 'active' 
 * correctly , however with the subsequent click event on the checkbox 
 * toggles it back to empty ( basically removes the class 'active').
 * **************************************************************************
 */
$( "label.woocommerce-form__label" ).change(function() {
    $(this).toggleClass('pxlr-woo-js-label__checked');
});

/**
 * Woocommerce Germanized Plugin will restructure the source and we have to tweek this and make it functional again
 */
$( ".woocommerce-checkout-review-order input[type=checkbox]" ).change(function() {
    $(this).next().find('p.legal label[for=legal]').toggleClass('pxlr-woo-js-label__checked');
});


/**
 * **************************************************************************
 * PXLR WOOCommerce Custom Minicart has been Updated bubble animation *******
 * **************************************************************************
 */
$( ".button.add_to_cart_button.ajax_add_to_cart" ).click(function() {
    $('body.woocommerce, body.page .wc-block-mini-cart__badge').removeClass('ajax-updated');
    $('body.woocommerce, body.page .wc-block-mini-cart__badge').addClass('ajax-updated');
});

/**
 * **************************************************************************
 * PXLR WOOCommerce Change Text on Coupon Button ****************************
 * Note: The Gutenbergblock to add copons code is in beta, unfortenantly ****
 * they have no translation yet and the Strin is hard coded into the ********
 * gutenberg block. So thats why we change the text with jquery so far ******
 * The fact that the coupon element is also set by js needs a time **********
 * to be sure that the element exist in the dom befor change the text *******
 * **************************************************************************
 */

var pxlr_check_if_couponbox_exist_condition = setInterval(function() {
    if ($('.wc-block-components-totals-coupon-link').length) {
       //console.log("Exists!");
       $(".wc-block-components-totals-coupon-link").addClass('pxlr-js-modded').text("Coupon einlösen");
       clearInterval(pxlr_check_if_couponbox_exist_condition);
    }
   }, 100); // check every 100ms

/**
 * **************************************************************************
 * PXLR WOOCommerce Page Card Shipping Calculator ***************************
 * Note: The open function is on Woo Core js ********************************
 * We toggle just a class to parent elements to do some magic ***************
 * **************************************************************************
 */
// $( ".shipping-calculator-button" ).click(function() {
//     $('.woocommerce-shipping-calculator .shipping-calculator-form').toggleClass('pxlr-shipping-calculator-open');
// });


/**
 * **************************************************************************
 * PXLR WOOCommerce Custom Accordion for productpage - Show hide content ****
 * **************************************************************************
 */

$(".pxlr-woo-product-accordion-wrapper .pxlr-woo-product-accordion-item-wrapper").each(function(index) {
    // in case if you want one element should be open whilke loading
    if ($(this).hasClass("is-active")) {
        $(this).find(".pxlr-woo-product-accordion-item-content").slideDown(200);
    }
    // act when clicked
    $(this).find(".pxlr-woo-product-accordion-item-bar").click(function() {
        if ($(this).hasClass("is-active")) {
            $(this).removeClass("is-active"); //Item Bar
            $(this).parent().removeClass("is-active"); //Item Wraper
            $(this).siblings(".pxlr-woo-product-accordion-item-content").slideUp(200);
        } else {
            $(".pxlr-woo-product-accordion-item-bar").each(function() {
                $(this).parent().removeClass("is-active");
                $(this).removeClass("is-active");
            });

            $(this).addClass("is-active"); //Item Bar
            $(this).parent().addClass("is-active"); //Item Wraper
            $(".pxlr-woo-product-accordion-item-content").slideUp(200);
            $(this).siblings(".pxlr-woo-product-accordion-item-content").slideDown(200);
        }
    });
});